// jyorderCreate store 主入口
// 合并各功能模块

import { state, mutations as stateMutations } from './state'
import { actions as apiActions } from './api'
import { getters as baseGetters } from './base'
import { getters as carrierGetters } from './carrier'
import { getters as hctFeeGetters } from './hctFee'
import { getters as seaGetters } from './sea'
import { getters as addressGetters, actions as addressActions } from './address'
import { getters as discountGetters } from './discount'
import { getters as couponGetters } from './coupon'
import { getters as declItemsGetters } from './declItems'
import { getters as useFeeTypeGetters, mutations as useFeeTypeMutations, actions as useFeeTypeActions } from './useFeeType'
import { getters as feeSummaryGetters } from './feeSummary'
import { mutations as viewStateMutations, actions as viewStateActions } from './viewState'

// 合并 getters
const getters = {
  ...baseGetters,
  ...carrierGetters,
  ...hctFeeGetters,
  ...seaGetters,
  ...addressGetters,
  ...discountGetters,
  ...couponGetters,
  ...declItemsGetters,
  ...useFeeTypeGetters,
  ...feeSummaryGetters,
}

// 合并 mutations
const mutations = {
  ...stateMutations,
  ...useFeeTypeMutations,
  ...viewStateMutations,
}

// 合并 actions
const actions = {
  ...apiActions,
  ...addressActions,
  ...useFeeTypeActions,
  ...viewStateActions,
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
